// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { cmsApi } from '../cmsApi'; // For JS docs use.

/**
 * The list of RTK tags used across the application.
 */
export const appTagList = [
  // ----- Grower tags -----
  'Grower',
  'Growers',
  // ----- Block tags  -----
  'RecentBlocks',
  'HarvestableBlocks',
  'PendingBlocks',
  'BlocksToSchedule',
  'Block',
  'Evaluation',
  'Estimate',
  // ----- Scheduling tags -----
  'PackingHouses',
  'PickPlan',
  'ScheduledPick',
  'DayScheduleSummary',
  // ----- Harvest tags  -----
  'Seasons',
  'Pools',
  'PickRates',
  'HaulRates',
  'TransferRates',
  'SurchargeRates',
  'OtherRates',
  'RangeLabels',
  'HarvestCrews',
  'CtrPayroll',
  // ----- Variety tags -----
  'Varieties',
  'SubVarieties',
  'SubVarietiesWithVar',
  'RootstocksWithVar',
  'Sizes',
  // ----- Location tags -----
  'Area',
  'County',
  'District',
  // ----- User tags -----
  'User',
  'Users',
  'UsersByRoles',
  'Roles',
] as const;

/**
 * A strictly typed version of the {@link appTagList} array to enforce typing
 * when invalidating tags in RTK endpoint definitions.
 *
 * @remark It is only used during {@link cmsApi} configuration.
 */
export const readOnlyAppTagList: readonly (typeof appTagList)[number][] =
  appTagList;
